define('chaves-controller',[
    'chaves-resource',
    'imovel-resource',
], function() {

    var app = angular.module('chaves.controller', [
        'chaves.resource',
        'imovel.resource',
    ]);

    app.controller('ChavesControllerIndex', ['$scope', '$rootScope', 'Chaves','Imovel', function($scope, $rootScope, Chaves, Imovel) {
        console.log('abc d');
        $scope.chaves = [];
        $scope.getSolicitacoesChave = function(){
            $scope.chaves = [];
            Imovel.getSolicitacoesChave({}).then(function (result) {
                if(result.data.chaves){
                    $scope.chaves = result.data.chaves;
                }
            });
        };

        $scope.showSolicitacoesList = function() {
            $scope.solicitacaoListModal = true;
        };

        $scope.cancelarSolicitacao = function(so_codigo){
            Imovel.cancelarSolicitacaoChave({so_codigo: so_codigo}).then(function (result) {
                $scope.getSolicitacoesChave();
            });
        };


        $scope.getSolicitacoesChave();

    }]);
});

